import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@/assets/locales/en.json";
import es from "@/assets/locales/es.json";
import fr from "@/assets/locales/fr.json";
import zh from "@/assets/locales/zh.json";
import ja from "@/assets/locales/ja.json";
import de from "@/assets/locales/de.json";
import pt from "@/assets/locales/pt.json";
import ar from "@/assets/locales/ar.json";
import nl from "@/assets/locales/nl.json";
import it from "@/assets/locales/it.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  zh: { translation: zh },
  ja: { translation: ja },
  de: { translation: de },
  pt: { translation: pt },
  ar: { translation: ar },
  nl: { translation: nl },
  it: { translation: it },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["cookie"],
    },
  });

export default i18n;
